import React from "react"
import Container from "../container/Container"

const Section = ({ classNames, children, container, ...otherProps }) => {
  const sectionClassName = classNames || ""
  const containerClassName = container || ""

  return (
    <section
      className={sectionClassName}
      {...otherProps}
    >
      {containerClassName ? (
        <Container className={containerClassName}>{children}</Container>
      ) : (
        children
      )}
    </section>
  )
}

export default Section
